import { createFileRoute } from '@tanstack/react-router'
import AdminRunsPage from '@/components/pages/Admin/AdminRunsPage/AdminRunsPage'
import { z } from 'zod'

const searchSchema = z.object({
  page: z.number().optional(),
  query: z.string().optional(),
  sort_by: z.string().optional(),
  sort_order: z.string().optional(),
  status: z.array(z.string()).optional(),
  account_id: z.array(z.string()).optional(),
  app_id: z.string().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/admin/runs/')({
  validateSearch: (search) => searchSchema.parse(search),
  component: AdminRunsRoute,
})

function AdminRunsRoute() {
  return <AdminRunsPage />
}
